export default __webpack_public_path__ + "static/media/LSTM-All.fd1785c2.png";